export default {
  FETCH_BE_APP_VERSION_REQUEST: 'FETCH_BE_APP_VERSION_REQUEST',
  FETCH_BE_APP_VERSION_SUCCESS: 'FETCH_BE_APP_VERSION_SUCCESS',
  FETCH_BE_APP_VERSION_FAILURE: 'FETCH_BE_APP_VERSION_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-app-version/actions/app-version.action-types.js